module.exports = __webpack_public_path__ + "static/media/Rainbow.866ae0e3.PNG";